var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('GraphicsTwo',{attrs:{"labels":_vm.labels,"data":_vm.data,"highestValue":_vm.highestValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }